import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import type { SupportedLanguage } from "./config";
import { persistLanguage, readPathLanguage, readStoredLanguage } from "./storage";

/**
 * Keeps i18next in sync with the URL prefix for public routes.
 * `/es/...` → Spanish. Anything else → stored preference, then default.
 * Mount once inside <BrowserRouter>.
 */
export const LanguageSync = () => {
  const { i18n } = useTranslation();
  const { pathname } = useLocation();

  useEffect(() => {
    const fromPath = readPathLanguage(pathname);
    const target: SupportedLanguage = fromPath ?? readStoredLanguage();
    if (i18n.language !== target) {
      void i18n.changeLanguage(target);
    }
    if (fromPath) persistLanguage(fromPath);
  }, [pathname, i18n]);

  return null;
};
